export const LIST_REVIEWS = 'LIST_REVIEWS';
export const LIST_REVIEWS_SUCCESS = 'LIST_REVIEWS_SUCCESS';
export const LIST_REVIEWS_FAILED = 'LIST_REVIEWS_FAILED';
